import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Stack from '@mui/material/Stack';
import { PopupButton, InlineWidget } from "react-calendly";
import Base13Icon from './../../Color just logo - no background.svg';
import SnowflakeLogo from './../../Snowflake_logo.png';
import RedshiftLogo from './../../redshiftLogo.png';
import BigQueryLogo from './../../bigqueryLogo.png';
import PostgreSQLLogo from './../../postgresqlLogo.png';
import MySQLLogo from './../../mysqlLogo.png';
import RedashLogo from './../../redash_logo.png';

import Header from './Header';
import Footer from './Footer';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  snowflakeLogoSmall: {
    width: '75vw',
    maxWidth: 200,
    // height: 256,
  },
  redshiftLogo: {
    width: '75vw',
    maxWidth: 150,
    // height: 256,
  },
  bigqueryLogo: {
    width: '75vw',
    maxWidth: 150,
    // height: 256,
  },
  postgresqlLogo: {
    width: '75vw',
    maxWidth: 150,
    // height: 256,
  },
  button: {
    margin: theme.spacing(1),
    justifyContent: 'left',
    justify: 'left',
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  // image: {
  //   flex: 1,
  //   padding: 2,
  //   width: 100,
  //   height: 100,
  //   resizeMode: 'contain'
  // },
  text: {
    margin: theme.spacing(1),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardContent: {
    backgroundColor: 'white',
    color: '#0284c7'
  },
}));

export default function SelectDestination() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>

       <Container maxWidth="lg" component="main" className={classes.heroContent} style={{color:"#37474f"}} >
          <Box style={{padding: 70}}></Box>
          <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{paddingTop:30, paddingBottom:20}}
          >
            <img className={classes.image} src={Base13Icon}/>
          </Box>
          <Typography component="h3" style={{padding:20}} variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textSecondary" gutterBottom>
            Select a destination for your data.
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:20}}
            >
              <Link href='/FloSQLRedshift'><img className={classes.postgresqlLogo} src={PostgreSQLLogo} href='/FloSQLRedshift'/></Link>
              <img className={classes.dwdblogoPadding} />
              <Link href='/FloSQLRedshift'><img className={classes.redshiftLogo} src={RedshiftLogo} href='/FloSQLRedshift'/></Link>
              <img className={classes.dwdblogoPadding} />
              <Link href='/FloSQLSnowflake'><img className={classes.snowflakeLogoSmall} src={SnowflakeLogo} href='/FloSQLSnowflake'/></Link>
              <img className={classes.dwdblogoPadding} />
              <Link href='/FloSQLBigQuery'><img className={classes.bigqueryLogo} src={BigQueryLogo}/></Link>
          </Stack>
          {/*<Typography variant="h5" style={{ fontFamily: 'Arial', padding:20 }} align="center" color="textSecondary" component="p">
            We accept payments in the following currencies
          </Typography>*/}
          <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:10}}
          >
          {/*<Box m="auto" className={classes.button}><Button size="large" href='https://buy.stripe.com/aEU6s92gI8OV9Mc3cc' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7"}} target="_blank" >USD</Button></Box>*/}
         {/* <Box className={classes.button}><Button size="large" href='https://buy.stripe.com/8wM4k1cVmghnaQgbIJ' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7"}} target="_blank" >CAD</Button></Box>*/}
          </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:50}}
        >
        </Box>

        </Container>
      <Footer/>
    </React.Fragment>
  );
};
